<template>
  <web-hls-video :hls-playlist-url="hlsPlaylistUrl" :loading="loading" class="hls-video-player">
    <video
      controls
      :autoplay="autoplay"
      :muted="autoplay"
      :loop="autoplay"
      playsinline
      controlslist="nodownload noremoteplayback"
      disablepictureinpicture
      class="video-element"
    />

    <img :src="posterImageUrl" :alt="posterImageAlt" class="poster-image" />

    <button
      class="play-button"
      aria-label="Play video"
      :style="{ backgroundColor: themeBgColor, color: themeTextColor }"
    >
      <i-play />
    </button>
  </web-hls-video>
</template>

<script setup>
import { computed } from "vue";

import { useThemeColor } from "@/composables/useThemeColor.js";
const { themeBgColor, themeTextColor } = useThemeColor();

const props = defineProps({
  hlsPlaylistUrl: String,
  posterImage: Object,
  loading: {
    type: String,
    default: "lazy",
  },
  autoplay: {
    type: Boolean,
    default: false,
  },
});

const posterImageUrl = computed(() => {
  if (typeof props.posterImage === "string") return props.posterImage;
  return props.posterImage?.filename || "";
});

const posterImageAlt = computed(() => {
  if (typeof props.posterImage === "string") return "Video poster";
  return props.posterImage?.alt || "Video poster";
});
</script>

<style lang="scss" scoped>
.hls-video-player {
  position: relative;
  display: block;
  width: 100%;
  padding-top: 56.25%; /* 16:9 aspect ratio */
  :deep(iframe) {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.video-element {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.poster-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  opacity: 0;
  transition: opacity 400ms;
}

.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: grid;
  border-radius: 999px;
  padding: 8px;
  cursor: pointer;
  pointer-events: none;
  opacity: 0;
  transition: opacity 400ms;
  svg {
    width: 40px;
    height: auto;
  }
}

.hls-video-player:not(.hide-poster) {
  .poster-image {
    opacity: 1;
  }
  .play-button {
    opacity: 1;
    pointer-events: auto;
  }
}
</style>
